// Status das notas fiscais gravados pelo servidor (status da Spedy em maiúsculas + status internos)
const STATUS_NOTA = {
    PENDENTE: { label: 'Processando', tone: 'warning' },
    AUTHORIZED: { label: 'Emitida', tone: 'success' },
    REJECTED: { label: 'Rejeitada', tone: 'error' },
    DENIED: { label: 'Denegada', tone: 'error' },
    ERRO: { label: 'Erro no envio', tone: 'error' },
    'CANCELAMENTO EM ANDAMENTO': { label: 'Cancelando', tone: 'warning' },
    CANCELED: { label: 'Cancelada', tone: 'neutral' },
    REMOVED: { label: 'Removida', tone: 'neutral' },
    DISABLED: { label: 'Inutilizada', tone: 'neutral' },
};

export const statusNota = (status) => STATUS_NOTA[status] || { label: status || '—', tone: 'neutral' };

// PDF existe a partir da autorização (inclusive notas canceladas)
export const podeBaixarPdf = (status) => ['AUTHORIZED', 'CANCELAMENTO EM ANDAMENTO', 'CANCELED'].includes(status);

export const podeCancelar = (status) => status === 'AUTHORIZED';

// dadosNFSe pode chegar como objeto ou como string JSON (registros antigos)
export const dadosNota = (nota) => {
    let dados = nota?.dadosNFSe;
    while (typeof dados === 'string') {
        try {
            dados = JSON.parse(dados);
        } catch {
            return {};
        }
    }
    if (!dados || typeof dados !== 'object') return {};
    return dados.event && dados.data ? dados.data : dados;
};

export const tomadorNota = (nota) => dadosNota(nota).receiver?.name || '';

// Motivo informado pela prefeitura/Spedy quando a nota é rejeitada
export const mensagemNota = (nota) => dadosNota(nota).processingDetail?.message || '';
